import React, { FC } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import { ProClientL1Icon } from '@fiverr-private/visuals';

export interface CompanyLogoProps {
    logoUrl?: string;
    name: string;
    size?: number;
}

export const CompanyLogo: FC<CompanyLogoProps> = ({ logoUrl, name, size = 48 }) =>
    logoUrl ? (
        <Image height={`${size}px`} width={`${size}px`} borderRadius="sm" alt={name.replace(' ', '_')} src={logoUrl} />
    ) : (
        <Stack height={`${size}px`} width={`${size}px`} backgroundColor="grey_300" borderRadius="sm" flexShrink={0}>
            <Stack margin="auto">
                <ProClientL1Icon />
            </Stack>
        </Stack>
    );
